import { ConfigStore } from '@yarmill/types';
import { useRootStore } from './use-root-store';

type ConfigKey = keyof ConfigStore;
export function useConfig<P extends ConfigKey>(configKey: P): ConfigStore[P] {
  return useRootStore().configStore[configKey];
}
